import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

export default function DeliveryOrderStatus(value) {
  return (
    <Typography
      style={{
        padding: "5px",
        background: "#075444",
        color: "white",
      }}
    >
      {(() => {
        switch (value.value) {
          case 1:
            return "DITERBITKAN";
          case 2:
            return "DIKIRIM";
          case 3:
            return "DITERIMA";  
          case 4:
            return "SJ KEMBALI";  
          case 5:
            return "INVOICE";  
          default:
            return null;
        }
      })()}
    </Typography>
  );
}

DeliveryOrderStatus.propTypes = {
  value: PropTypes.any,
};
